export const OTPAD_V1ResourcesEN: OTPAD_V1ResourcesBSInterface = {
  errors: {
    registerPic: "The picture you are uploading is too large.",
    recordAlreadyExists:
      "This evidence has already been filled out. You cannot fill it out again.",
  },
  input: {
    datum: {
      name: "datum",
      label: "Task completion date",
      placeholder: "Enter date",
    },
    vrstaOtpada: {
      name: "vrstaOtpada",
      label: "Enter waste type",
      placeholder: "Enter waste type",
    },
    jedinicaMjere: {
      name: "jedinicaMjere",
      label: "Enter unit of measure",
      placeholder: "Enter unit of measure",
    },
    primaoc: {
      name: "primaoc",
      label: "Enter recipient name",
      placeholder: "Enter recipient name",
    },
    adekvatnoPrikupljen: {
      name: "adekvatnoPrikupljen",
      label: "Select if waste is adequately collected",
      error: "Please select if waste is adequately collected",
      placeholder: "Please select if waste is adequately collected",
    },
    korektivnaMjera: {
      name: "korektivnaMjera",
      label: "Corrective measure",
      placeholder: "Enter corrective measure",
    },
    kolicina: {
      name: "kolicina",
      label: "Quantity",
      placeholder: "Enter quantity",
    },
  },
  type: {
    EvdLabel: "Evidence type",
    Name: "type",
    Placeholder:
      "Enter: Regular, extraordinary, general, weekly, monthly, yearly...",
  },
  evidencijaForm: {
    buttonForward: "Sign",
    buttonBack: "Back",
  },
  successModal: {
    title: "Data Entry",
    body: "Data addition has been successfully completed. Select OK to continue.",
    buttonOk: "OK",
  },
  txtPotvrda:
    "By selecting the Sign option, I confirm that the task has been performed according to the instructions!",
  dropdownOptions: {
    da: "Yes",
    ne: "No",
    undefined: "Please select field",
  },
};

interface InputField {
  name: string;
  label: string;
  placeholder?: string;
  error?: string;
}

interface Input {
  datum: InputField;
  vrstaOtpada: InputField;
  jedinicaMjere: InputField;
  primaoc: InputField;
  adekvatnoPrikupljen: InputField;
  korektivnaMjera: InputField;
  kolicina: InputField;
}

interface Type {
  EvdLabel: string;
  Name: string;
  Placeholder: string;
}

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

interface IDropdownOptions {
  da: string;
  ne: string;
  undefined: string;
}

interface IErrors {
  registerPic: string;
  recordAlreadyExists: string;
}

export interface OTPAD_V1ResourcesBSInterface {
  input: Input;
  type: Type;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
  dropdownOptions: IDropdownOptions;
  errors: IErrors;
}
